import styled from "@emotion/styled";

import { MDSDialogSlotName } from "@/mds/components/overlays/dialog";
import { APP_CONFIG } from "@/domains/global/config";
import {
  PaywallHeader,
  PaywallModalDialog,
} from "@/components/modal/paywall/paywall-modal-components";
import { PROACTIVE_MONEY_BACK_GUARANTEE_NOTE } from "@/components/modal/proactive-upsell/proactive-plan";
import { ProactiveTrialPitch } from "@/components/proactive-trial/proactive-trial-pitch";

import { getLearnMoreHrefWithPrice } from "./learn-more-href";

export interface ProactiveUpsellModalViewProps {
  isOpen: boolean;
  isTrialEligible: boolean;
  title?: string;
  onClose: () => void;
  onSubscribe: () => void;
  onRetryPricing?: () => void;
  learnMoreHref?: string;
  isSubscribing?: boolean;
  proactivePrice?: string;
  proactivePriceCents?: number;
  pricingIsLoading?: boolean;
  pricingError?: string;
}

export const ProactiveUpsellModalView = ({
  isOpen,
  isTrialEligible,
  title,
  onClose,
  onSubscribe,
  learnMoreHref = APP_CONFIG.URLS.MEM_AGENT_DOCS,
  isSubscribing = false,
  onRetryPricing,
  proactivePrice,
  proactivePriceCents,
  pricingIsLoading = false,
  pricingError,
}: ProactiveUpsellModalViewProps) => {
  const learnMoreHrefWithPrice = getLearnMoreHrefWithPrice({
    learnMoreHref,
    proactivePriceCents,
  });

  return (
    <ProactiveUpsellModalDialog
      isOpen={isOpen}
      handleClose={onClose}
      dialogWidth="854px"
      data-proactive-upsell-modal
    >
      <PaywallHeader slot={MDSDialogSlotName.Header} aria-hidden="true" />

      <ModalPitchContent slot={MDSDialogSlotName.Content}>
        <ProactiveTrialPitch
          actionNote={PROACTIVE_MONEY_BACK_GUARANTEE_NOTE}
          heading={title}
          isActionLoading={isSubscribing}
          isTrialEligible={isTrialEligible}
          learnMoreHref={learnMoreHrefWithPrice}
          onRetryPricing={onRetryPricing ?? onSubscribe}
          onSubscribe={onSubscribe}
          proactivePrice={proactivePrice}
          pricingError={pricingError}
          pricingIsLoading={pricingIsLoading}
        />
      </ModalPitchContent>
    </ProactiveUpsellModalDialog>
  );
};

const ProactiveUpsellModalDialog = styled(PaywallModalDialog)`
  .mds-dialog {
    height: auto;
    max-height: calc(100dvh - 40px);
  }

  [data-mds-name="dialog-body"] {
    display: flex;
    min-height: 0;
  }

  @media (max-width: 700px) {
    .mds-dialog {
      height: calc(100dvh - 32px);
    }
  }
`;

const ModalPitchContent = styled.div`
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  min-height: 0;
`;
